import { useBytecode } from 'wagmi';

import { isEthereumAddress } from '@/utils/models';

type SignerIntentsApprovalSupportArgs = {
  address: string | undefined;
  chainId: number | undefined;
  enabled: boolean;
};

export function useSignerIntentsApprovalSupport({
  address,
  chainId,
  enabled,
}: SignerIntentsApprovalSupportArgs) {
  const validAddress = address !== undefined && isEthereumAddress(address);
  const queryEnabled = enabled && validAddress && chainId !== undefined;
  const { data, status, isFetching, refetch } = useBytecode({
    address: validAddress ? address : undefined,
    chainId,
    query: { enabled: queryEnabled, retry: false },
  });

  if (!queryEnabled) return { status: 'unavailable' as const };
  // A refetch may change whether the signer needs a permit. Hide the old result.
  if (isFetching || status === 'pending') return { status: 'loading' as const };
  if (status === 'error') return { status: 'error' as const, refetch };

  return {
    status: 'ready' as const,
    supportsApproval: data == null || data === '0x',
  };
}
